import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import { visuallyHidden } from "@mui/utils";
import {
  parkingsCollection,
  usersCollection,
} from "../../firebase/firestoreUtils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { openModal } from "../../redux/actions";

// const rows = [...carParkData];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
// Column Titles:
const headCells = [
  {
    id: "carParkName",
    numeric: false,
    disablePadding: false,
    label: "Car Park Name",
  },
  {
    id: "organisation",
    numeric: false,
    disablePadding: false,
    label: "Organisation",
  },

  {
    id: "primaryContact",
    numeric: false,
    disablePadding: false,
    label: "Primary Contact OWNER",
  },
  {
    id: "userGroupContact",
    numeric: false,
    disablePadding: false,
    label: "Users Group Contact ADMIN",
  },
  {
    id: "subscriptionFrom",
    numeric: false,
    disablePadding: false,
    label: "Subscription From",
  },
  {
    id: "subscriptionTo",
    numeric: false,
    disablePadding: false,
    label: "Subscription To",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "edit",
    numeric: false,
    disablePadding: false,
    label: "Edit",
  },
  {
    id: "delete",
    numeric: false,
    disablePadding: false,
    label: "Delete",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,

    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  // Showing rows:
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const CarParkTable = () => {
  const { currentUser } = useSelector((state) => state);

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [usersList, setUsersList] = React.useState([]); //stan users
  const [parkings, setParkings] = React.useState([]); //stan parkings

  const dispatch = useDispatch();
  // get data from firebase:
  useEffect(() => {
    usersCollection.get().then((response) => {
      setUsersList(response.docs.map((el) => ({ id: el.id, ...el.data() })));
    });

    parkingsCollection.get().then((response) => {
      setParkings(response.docs.map((el) => ({ id: el.id, ...el.data() })));
    });
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = parkings.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const addYear = (date) => {
    date.setFullYear(date.getFullYear() + 1);
    return date;
  };
  //  ______________ get Owner Id: ______________________
  const getParkingOwner = (parking) => {
    return usersList.find((user) => {
      return user.userId === parking.userId;
    });
  };
  // _____________ get Admin Id: ______________
  const getParkingAdmin = (parking) => {
    return usersList.find((user) => {
      return user.userId === parking.adminId;
    });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - parkings.length) : 0;

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={parkings.length}
            />
            <TableBody>
              {stableSort(parkings, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      {/* _____________ Parking Name: ______________________________ */}
                      <TableCell align="left">{row.parkingName}</TableCell>
                      {/* ______________________ Company Name: ___________________ */}
                      <TableCell align="left">{row.companyName}</TableCell>

                      {/* _________________ Name and role of Owner: _________________ */}
                      <TableCell align="left">
                        {getParkingOwner(row)?.firstName}{" "}
                        {getParkingOwner(row)?.surname}
                        {" ("}
                        {getParkingOwner(row)?.role}
                        {")"}
                      </TableCell>
                      {/* _________________ Name and role of Admin-User Group: _________________ */}
                      <TableCell align="left">
                        {getParkingAdmin(row)?.firstName}{" "}
                        {getParkingAdmin(row)?.surname}
                        {" ("}
                        {getParkingAdmin(row)?.role}
                        {")"}
                      </TableCell>
                      {/* ______________Date of subscription started:_______________ */}
                      <TableCell align="left">
                        {new Date(row.created_date).toDateString()}
                      </TableCell>

                      {/* __________ date when subscription will end after 1 year:___________ */}
                      <TableCell align="left">
                        {addYear(new Date(row.created_date)).toDateString()}
                      </TableCell>

                      {/* ____________ Showing status Active/Unactive car park 1 year from date of car park set up:_____________ */}
                      <TableCell align="left">
                        {new Date().getTime() >=
                          new Date(row.created_date).getTime() &&
                        new Date().getTime() <=
                          addYear(new Date(row.created_date)).getTime()
                          ? "ACTIVE"
                          : "UNACTIVE"}
                      </TableCell>

                      {/* _________________ Edit row:_______________________________________ */}
                      {(currentUser.role === "master" ||
                        currentUser.role === "owner") && (
                        <TableCell align="left">
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() =>
                                dispatch(openModal("editCarPkAdmin", row))
                              }
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      )}

                      {/* __________________ Delete row:______________________________ */}
                      {(currentUser.role === "master" ||
                        currentUser.role === "owner") && (
                        <TableCell align="left">
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() =>
                                dispatch(
                                  openModal(
                                    "delete",
                                    "parking",
                                    "parkings",
                                    row.id
                                  )
                                )
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      )}
                      {/* _________________ Delete End __________________*/}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                // style={{
                //   height: (dense ? 33 : 53) * emptyRows,
                // }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={parkings.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
};

export default CarParkTable;
